export const modifyToken = (token) => {
  switch (token.type) {
    case 'heading_open':
      token.attrObj.class = 'tw-text-4xl tw-text-gray-900 tw-mb-2';
      break;
    case 'bullet_list_open':
      token.attrObj.class = 'tw-list-disc tw-list-inside';
      break;
    case 'ordered_list_open':
      token.attrObj.class = 'tw-list-decimal tw-list-inside';
      break;
    case 'strong_open':
      token.attrObj.class = 'tw-font-extrabold tw-text-gray-800';
      break;
    default:
      break;
  }
};
